import script from "./Logistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Logistics.vue?vue&type=script&setup=true&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=5291833a&lang=css"

const __exports__ = script;

export default __exports__